import { RiArrowDropDownLine } from "react-icons/ri";
import { IoAddOutline } from "react-icons/io5";
import { SlSizeFullscreen } from "react-icons/sl";
import { FaLocationDot } from "react-icons/fa6";
import { GrDirections } from "react-icons/gr";
import { MdOutlineStar } from "react-icons/md";
import { AiFillEdit } from "react-icons/ai";
import { AiFillDelete } from "react-icons/ai";
import { SiGoogleclassroom } from "react-icons/si";
import { GiPriceTag } from "react-icons/gi";
import { BsPhoneVibrateFill } from "react-icons/bs";
import { FaUserEdit } from "react-icons/fa";
import { TiEdit } from "react-icons/ti";
import { IoSearch } from "react-icons/io5";
import { MdNavigateNext } from "react-icons/md";
import { IoSettingsSharp } from "react-icons/io5";
import { FaCamera } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";
import { IoEyeSharp } from "react-icons/io5";
import { IoMdLogOut } from "react-icons/io";
import { FaCloudArrowDown } from "react-icons/fa6";
import { HiArrowSmallUp } from "react-icons/hi2";
import { IoPlayOutline } from "react-icons/io5";
import { FaPencil } from "react-icons/fa6";

const icons = {
    RiArrowDropDownLine,
    IoAddOutline,
    SlSizeFullscreen,
    FaLocationDot,
    GrDirections,
    MdOutlineStar,
    AiFillEdit,
    AiFillDelete,
    SiGoogleclassroom,
    GiPriceTag,
    BsPhoneVibrateFill,
    FaUserEdit,
    TiEdit,
    IoSearch,
    MdNavigateNext,
    IoSettingsSharp,
    FaCamera,
    MdDeleteForever,
    IoEyeSharp,
    IoMdLogOut,
    FaCloudArrowDown,
    HiArrowSmallUp,
    IoPlayOutline,
    FaPencil
}

export default icons;